var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_vm._v("\n    "+_vm._s(_vm.message || _vm.$t('components.loading_message.operation_in_progress'))+"\n    "),_c('v-progress-linear',{staticClass:"mt-2",attrs:{"indeterminate":"","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }